'use client';

import { formatNumber } from '@ahm/common-helpers';
import { Progress, Text, Group, rem } from '@mantine/core';
import { useTranslations } from 'next-intl';
import CustomImage from '@/components/custom-image';

type Props = {
  usedNumber: number;
  totalNumber: number;
  className?: string;
  isExpired: boolean;
  isNotStart: boolean;
  isOutOfStock: boolean;
};

export default function FlashSaleBar({
  usedNumber,
  totalNumber,
  isExpired,
  isNotStart,
  isOutOfStock,
}: Props) {
  const t = useTranslations('rewards');
  const percent =
    isExpired || isOutOfStock
      ? 100
      : isNotStart
        ? 5
        : (usedNumber / totalNumber) * 100;
  const fillColor = isExpired
    ? '#C1C7CD'
    : 'linear-gradient(90deg, var(--functional-red-red-60-text-error-icon, #DA1E28) 0%, var(--Brand-Orange-Orange-40, #FEA362) 100%)';

  return (
    <Progress.Root my={4} radius="xl" size="xl" bg="#FFD5BC">
      <Progress.Section
        value={percent}
        style={{
          background: fillColor,
          borderRadius: 16,
        }}
      ></Progress.Section>
      <Progress.Label pos="absolute" top={0} left={0}>
        <Group px="xs" gap={6} align="center">
          <CustomImage
            src={`/static/images/rewards/flame.png`}
            alt="flashsale"
            width={7}
            height={8}
          />

          <Text fz={rem(10)} lh={rem(16)} fw={700} c="white">
            {isExpired
              ? t('flash_sale.expired')
              : isNotStart
                ? t('flash_sale.comingSoon')
                : `${formatNumber(usedNumber)}/${formatNumber(totalNumber)}`}
          </Text>
        </Group>
      </Progress.Label>
    </Progress.Root>
  );
}
